<script>
export default {
	data() {
		return {
			open: false,
		};
	},
};
</script>

<template>
<ul
	:class="[
		{ open: open },
		'ro-nav-parent',
	]"
>
	<slot />
</ul>
</template>



// WEBPACK FOOTER //
// RoNavParent.vue?39ad7690